/* istanbul ignore file */

import {breakpoints} from "@next/themes"

export const LayoutStyling = `
${`@media (max-width:${breakpoints.values.lg - 1}px)`} {
    .plp-filters-component-desktop {
        display: none;
    }
}
`
